// extracted by mini-css-extract-plugin
var _1 = "HoverView-module__floating--Pn49q";
var _2 = "HoverView-module__isClosed--bDlYf";
export { _1 as "floating", _2 as "isClosed" }
